import * as React from 'react';
import styled from 'styled-components';

const HomeBanner = styled.div`
  display: grid;
  height: 500px;
  align-content: center;
  justify-content: center;
`;

const HomeUpsell1 = styled.div`
  display: grid;
  height: 300px;
  align-content: center;
  justify-content: center;
  background: #eee;
`;

const HomeUpsell2 = styled.div`
  display: grid;
  height: 300px;
  align-content: center;
  justify-content: center;
`;

const Home = () => (
  <div>
    <HomeBanner>Home Banner</HomeBanner>
    <HomeUpsell1>Upsell 1</HomeUpsell1>
    <HomeUpsell2>Upsell 2</HomeUpsell2>
    <HomeUpsell1>Upsell 3</HomeUpsell1>
    <HomeUpsell2>Upsell 4</HomeUpsell2>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.tsx